import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useClasses from '../../../../hooks/useClasses';
import useRoutes from '../../../../hooks/useRoutes';

const InvalidPasswordResetToken = () => {
  const { resetPasswordRequest } = useRoutes();
  const { buildClass } = useClasses('ResetPassword');

  const { t } = useTranslation();
  return (
    <>
      <div className={buildClass('title')}>
        <h1>{t('pages.reset_password.title')}</h1>
      </div>
      <p>{t('pages.reset_password.error')}</p>
      <Button
        href={resetPasswordRequest}
        type="primary"
        className={buildClass('button')}
      >
        {t('buttons.back')}
      </Button>
    </>
  );
};

export default InvalidPasswordResetToken;
